var _a, _b, _c, _d, _e, _f, _g;
import { CardAdvancement, CardElement, CardFaction, CardGrade, CardRarity, CardType, } from '@cta-portal/webapp-common/lib/api/schema';
import airBackground from '../assets/images/card-elements/backgrounds/background-air.png';
import darkBackground from '../assets/images/card-elements/backgrounds/background-dark.png';
import earthBackground from '../assets/images/card-elements/backgrounds/background-earth.png';
import fireBackground from '../assets/images/card-elements/backgrounds/background-fire.png';
import lifeBackground from '../assets/images/card-elements/backgrounds/background-life.png';
import lightBackground from '../assets/images/card-elements/backgrounds/background-light.png';
import waterBackground from '../assets/images/card-elements/backgrounds/background-water.png';
// elements
import airIcon from '../assets/images/card-elements/icons/element-air.png';
import darkIcon from '../assets/images/card-elements/icons/element-dark.png';
import earthIcon from '../assets/images/card-elements/icons/element-earth.png';
import fireIcon from '../assets/images/card-elements/icons/element-fire.png';
import lifeIcon from '../assets/images/card-elements/icons/element-life.png';
import lightIcon from '../assets/images/card-elements/icons/element-light.png';
import waterIcon from '../assets/images/card-elements/icons/element-water.png';
import alternativeIcon from '../assets/images/icons/advancements/icon-alternative.png';
import comboIcon from '../assets/images/icons/advancements/icon-combo.png';
// advancement
import standardIcon from '../assets/images/icons/advancements/icon-standard.png';
// animation-levels
import animationLevel1Icon from '../assets/images/icons/animation-levels/icon-animation-lvl-1.png';
import animationLevel2Icon from '../assets/images/icons/animation-levels/icon-animation-lvl-2.png';
import animationLevel3Icon from '../assets/images/icons/animation-levels/icon-animation-lvl-3.png';
// card-types
import battleIcon from '../assets/images/icons/card-types/icon-battle.png';
import fieldIcon from '../assets/images/icons/card-types/icon-field.png';
// factions
import arkhanteIcon from '../assets/images/icons/collections/icon-arkhante.png';
import mantrisIcon from '../assets/images/icons/collections/icon-mantris.png';
import riftIcon from '../assets/images/icons/collections/icon-rift.png';
// foil
import foilIcon from '../assets/images/icons/foil/icon-foil.png';
import nonFoilIcon from '../assets/images/icons/foil/icon-non-foil.png';
import gradeAIcon from '../assets/images/icons/grades/icon-grade-a.png';
import gradeBIcon from '../assets/images/icons/grades/icon-grade-b.png';
// grades
import gradeCIcon from '../assets/images/icons/grades/icon-grade-c.png';
import gradeSIcon from '../assets/images/icons/grades/icon-grade-s.png';
// ranks
import rank1Icon from '../assets/images/icons/ranks/icon-rank-1.png';
import rank2Icon from '../assets/images/icons/ranks/icon-rank-2.png';
import rank3Icon from '../assets/images/icons/ranks/icon-rank-3.png';
import rank4Icon from '../assets/images/icons/ranks/icon-rank-4.png';
import rank5Icon from '../assets/images/icons/ranks/icon-rank-5.png';
import commonIcon from '../assets/images/icons/rarities/icon-common.png';
import exclusiveIcon from '../assets/images/icons/rarities/icon-exclusive.png';
// rarities
import mythicIcon from '../assets/images/icons/rarities/icon-mythic.png';
import rareIcon from '../assets/images/icons/rarities/icon-rare.png';
import specialRareIcon from '../assets/images/icons/rarities/icon-specialrare.png';
import ultraRareIcon from '../assets/images/icons/rarities/icon-ultrarare.png';
import uncommonIcon from '../assets/images/icons/rarities/icon-uncommon.png';
import uniqueIcon from '../assets/images/icons/rarities/icon-unique.png';
export var factionAssets = (_a = {},
    _a[CardFaction.ARKHANTE] = arkhanteIcon,
    _a[CardFaction.MANTRIS] = mantrisIcon,
    _a[CardFaction.RIFT] = riftIcon,
    _a);
export var elementAssets = (_b = {},
    _b[CardElement.AIR] = airIcon,
    _b[CardElement.DARK] = darkIcon,
    _b[CardElement.EARTH] = earthIcon,
    _b[CardElement.FIRE] = fireIcon,
    _b[CardElement.LIFE] = lifeIcon,
    _b[CardElement.LIGHT] = lightIcon,
    _b[CardElement.WATER] = waterIcon,
    _b);
export var elementBackgroundAssets = (_c = {},
    _c[CardElement.AIR] = airBackground,
    _c[CardElement.DARK] = darkBackground,
    _c[CardElement.EARTH] = earthBackground,
    _c[CardElement.FIRE] = fireBackground,
    _c[CardElement.LIFE] = lifeBackground,
    _c[CardElement.LIGHT] = lightBackground,
    _c[CardElement.WATER] = waterBackground,
    _c);
export var advancementAssets = (_d = {},
    _d[CardAdvancement.STANDARD] = standardIcon,
    _d[CardAdvancement.ALTERNATIVE] = alternativeIcon,
    _d[CardAdvancement.COMBO] = comboIcon,
    _d);
export var rarityAssets = (_e = {},
    _e[CardRarity.MYTHIC] = mythicIcon,
    _e[CardRarity.ULTRA_RARE] = ultraRareIcon,
    _e[CardRarity.RARE] = rareIcon,
    _e[CardRarity.UNCOMMON] = uncommonIcon,
    _e[CardRarity.COMMON] = commonIcon,
    _e[CardRarity.UNIQUE] = uniqueIcon,
    _e[CardRarity.EXCLUSIVE] = exclusiveIcon,
    _e[CardRarity.SPECIAL_RARE] = specialRareIcon,
    _e);
export var rankAssets = ['', rank1Icon, rank2Icon, rank3Icon, rank4Icon, rank5Icon];
export var gradeAssets = (_f = {},
    _f[CardGrade.C] = gradeCIcon,
    _f[CardGrade.B] = gradeBIcon,
    _f[CardGrade.A] = gradeAIcon,
    _f[CardGrade.S] = gradeSIcon,
    _f);
export var foilAssets = {
    true: foilIcon,
    false: nonFoilIcon,
};
export var animationLevelAssets = ['', animationLevel1Icon, animationLevel2Icon, animationLevel3Icon];
export var cardTypeAssets = (_g = {},
    _g[CardType.BATTLE] = battleIcon,
    _g[CardType.FIELD] = fieldIcon,
    _g);
export var collectionAssets = ['', arkhanteIcon, mantrisIcon, riftIcon];
